module.exports = __webpack_public_path__ + "static/11-fcf8450469847abccae1e4b8aa4d8bd7.jpeg";